export default "__VITE_ASSET__BgrPRzko__"